// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  stripeKey: "pk_live_51Jk4wYCDVfNkUyshe3910H0opDu4ILFkY4SqoyJgLoQ0t2efdUbw84JvWljWMGxB1SwfDUkP40DfQgxcFf4wUzlr00yLVhb2Li",
  stripeKeyIndia: "pk_live_51Ksg7HSDWfyfRjg7sUIDLmrxKvLBHIaZVBFWpKrtqPZFNvuI3ngnfSNiSsj39LTat7ESyW9fOxX66QrxTBOMOwqS00b8Yo073v",
  paypalClientID: "ARSw_7u4t-F6OKOF01kZSTeMoPhHIxeiW9cfsH18PHwgkD-Fqo9361qiq26j1t9Yb8ERKmWbRP2T0wWQ",
  baseWebSiteURL: "https://247invites.com/",
  baseURL: "https://api.247invites.com/",
  baseURLWithOutSlace: "https://api.247invites.com",
  siteURL: "https://247invites.com/",
  assetURL: "https://pub-f79427c950a84405a07a8998dcded99f.r2.dev",
  //assetURL: "https://pub-f79427c950a84405a07a8998dcded99f.r2.dev",
  cloudFrontAssetURL: "https://pub-f79427c950a84405a07a8998dcded99f.r2.dev",
  rsvpURL: "https://rsvp.247invites.com"
};
// export const environment = {
//   production: true,
//   stripeKey: "pk_live_51Jk4wYCDVfNkUyshe3910H0opDu4ILFkY4SqoyJgLoQ0t2efdUbw84JvWljWMGxB1SwfDUkP40DfQgxcFf4wUzlr00yLVhb2Li",
//   stripeKeyIndia: "pk_live_51Ksg7HSDWfyfRjg7sUIDLmrxKvLBHIaZVBFWpKrtqPZFNvuI3ngnfSNiSsj39LTat7ESyW9fOxX66QrxTBOMOwqS00b8Yo073v",
//   paypalClientID: "ARSw_7u4t-F6OKOF01kZSTeMoPhHIxeiW9cfsH18PHwgkD-Fqo9361qiq26j1t9Yb8ERKmWbRP2T0wWQ",
//   baseWebSiteURL: "https://stg.247invites.com/",
//   baseURL: "https://api.247invites.com/",
//   baseURLWithOutSlace: "https://api.247invites.com",
//   siteURL: "https://stg.247invites.com/",
//   assetURL: "https://pub-f79427c950a84405a07a8998dcded99f.r2.dev",
//   rsvpURL: "https://rsvp.247invites.com"
// };
// export const environment = {
//   production: false,
//   stripeKey: "pk_test_51Jk4wYCDVfNkUyshhWoBRy8DkCMXQpkmfK87tUk1xyEW8aD82afCVg5lH8EtEV3K4o73LNNiXPoZeoh2TghsclXc00TlUmCEy9",
//   stripeKeyIndia: "pk_test_51Ksg7HSDWfyfRjg7CodlukP2Qm2hDyHCdh0s5yGYztEw0HCk0aYYklKsASgtpzsXWuXjBUmG0mE6A04hGPHjDqAi00WjqNlzan",
//   paypalClientID: "AX9wTEeUI5AslHiKU5Q1UH6-FBuxG_mCTORn7QJz2xh7U08bXDgW0aTaA_5RrsIySY9u9R4nc9DfhmEJ",
//   baseWebSiteURL: "http://localhost:4200/",
//   // baseURL: "http://my.247invites.com/",
//   // baseURLWithOutSlace: "http://my.247invites.com",
//   baseURL: "http://localhost:8002/",
//   baseURLWithOutSlace: "http://localhost:8002",
//   siteURL: "http://localhost:4200/",
//   assetURL: "https://pub-f79427c950a84405a07a8998dcded99f.r2.dev",
//   cloudFrontAssetURL: "https://pub-f79427c950a84405a07a8998dcded99f.r2.dev",
//   rsvpURL: "https://rsvp.247invites.com"
// };
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
